<template>
  <v-ons-page>

    <v-ons-toolbar modifier="noshadow">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Échéance suivie</div>
    </v-ons-toolbar>

    <div class="content">

      <section class="content--perfecheance">

        <p class="title--perfalert">
          Quelle échéance souhaitez-vous suivre avec cette alerte&nbsp;?
        </p>
        <v-ons-button modifier="perfaide" @click="showAlertHelp = true">En savoir plus sur l'échéance</v-ons-button>

        <v-ons-list modifier="noborder perflist">

          <v-ons-list-item v-for="echeanceVal in echeanceList" modifier="nodivider perfradio"
                           :key="echeanceVal">
            <div class="left">
              <v-ons-radio modifier="material" :input-id="'radio'+echeanceVal" :value="echeanceVal"
                           v-model="echeance" :disabled="echeanceVal < echeanceCurrent">
              </v-ons-radio>
            </div>
            <label class="center" :for="'radio'+echeanceVal" :class="{'radio-button--disabled': echeanceVal < echeanceCurrent}">
              {{ getLabelEcheance(echeanceVal) }}
            </label>
          </v-ons-list-item>

        </v-ons-list>

      </section>

      <v-ons-bottom-toolbar modifier="cta transparent">
        <v-ons-button modifier="large--cta perflarge" @click="next">Valider</v-ons-button>
      </v-ons-bottom-toolbar>

    </div>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge'" :visible.sync="showAlertHelp">
      <template slot="title">
        <img class="alert-dialog-icon--perfbadge" src="../assets/imgs/icon_help@2x.png"><br />
        L'échéance
      </template>
      Le cours Euronext est différent d'une échéance à l'autre. Nous vous conseillons de choisir l'échéance sur laquelle vous souhaitez faire votre prochaine vente. Vous pourrez à tout moment revenir ici pour changer d'échéance. 
      <template slot="footer">
        <v-ons-alert-dialog-button @click="showAlertHelp = false">Ok, merci !</v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";

export default {
  mixins: [mixinsCommons, mixinsCours],
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      echeance: '',
      showAlertHelp: false,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    referentiel() {
      return this.data.referentiel;
    },
    coursName() {
      return this.referentiel.cultures[this.refCulture].destinations[this.refDestination].cours;
    },
    echeanceCurrent() {
      return this.data.cours[this.coursName].current;
    },
    echeanceList() {
      return this.getEcheanceList(this.coursName, this.campagne);
    }
  },
  methods: {
    next() {
      var strategie = {
        echeance: this.echeance
      };

      this.mergeJson(store.state.user.ventes[this.refCulture][this.refDestination], strategie);
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath('/alerte'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination,
            data: strategie
          }
        }
      });

      this.pageStack.pop();
    }
  },
  created() {
    var strategie = this.user.ventes[this.refCulture][this.refDestination];
    if (strategie.echeance) {
      this.echeance = strategie.echeance;
    } else {
      this.echeance = this.getEcheanceDefault(this.campagne, this.echeanceCurrent, this.echeanceList);
    }
  }
};
</script>

<style scoped>
.content--perfecheance {
  background: #fff;
  text-align: center;
}
.content--perfecheance .list--perflist {
  padding: 50px 25px;
}
</style>
